import axios from "axios";
import process from "process";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "http://localhost:5000";
} else if (window.location.hostname === "localhost") {
  axios.defaults.baseURL = "http://localhost:5000";
}

function Onboarding() {
  const navigateTo = useNavigate();
  const location = useLocation();
  const [accountState, setAccountState] = useState(null);
  const [seoName, setSeoName] = useState(null);
  // Parse the search string to get query parameters
  const queryParams = new URLSearchParams(location.search);
  const account_id = queryParams.get("account_id"); // Replace 'paramName' with the actual parameter name

  useEffect(() => {
    // Only define the function inside useEffect
    const fetchOnboardingData = async () => {
      try {
        const response = await axios.get("/api/onboarding", {
          params: { account_id: account_id },
          headers: { "X-Custom-Origin": "https://truzzer.com/" },
        });
        console.log(response.data.seo_name);
        // Update state with the fetched data
        setAccountState(response.data.error_code);
        if (response.data.seo_name) {
          setSeoName(response.data.seo_name);
        }
      } catch (error) {
        if (error.response) {
          setAccountState(error.response.data.error_code);
        } else {
          setAccountState(500);
        }
      }
    };

    if (account_id) {
      fetchOnboardingData();
    }
  }, [account_id]);
  useEffect(() => {
    if (accountState) {
      if (accountState === 200 && setSeoName) {
        navigateTo(`/${seoName}`);
      } else if (accountState === 200) {
        navigateTo(`/login`, {
          state: {
            message:
              "Account already exists, login and complete your Landing configuration.\n\nIf you are not the account owner notify the account owner of this.",
          },
        });
      } else if (accountState === 1) {
        navigateTo("/sign-up", { state: { account_id: account_id } });
      } else {
        navigateTo("/error-page", { state: { status: accountState } });
      }
    }
  }, [accountState]);
  return <></>;
}

export default Onboarding;
